import cn from 'classnames';
import { Stub, VStack } from '@direct-frontend/components';
import styles from './PageStub.module.css';

export const PageStub = ({ className }: { className?: string }) => (
    <VStack className={cn(styles.root, className)} gap="12">
        <Stub width="calc(100% - 20px)" height={40} borderRadius="14" />
        <Stub width="calc(100% - 20px)" height={65} borderRadius="14" />
        <Stub width="calc(100% - 20px)" height={120} borderRadius="14" />
    </VStack>
);
